import Rules, { RulesMode } from "@Front/Components/Elements/Rules";
import { AppRuleActions, AppRuleNames } from "@Front/Api/Entities/rule";
import ButtonHeader from "../../ButtonHeader";
import { Routes } from "@Front/Config/Routes";
import { notaryFolderNavArchivedLabel, notaryFolderNavCurrentLabel } from "@Front/Utils/applyFolderAsOperationFr";

export function FolderButtons(): React.ReactElement {
	return (
		<Rules
			mode={RulesMode.OPTIONAL}
			rules={[
				{
					action: "read" as AppRuleActions,
					name: AppRuleNames.officeFolders,
				},
			]}>
			<>
				<ButtonHeader
					text={notaryFolderNavCurrentLabel()}
					path={Routes.pages.Folder.base}
					routesActive={[Routes.pages.Folder.FolderInformation, Routes.pages.Folder.CreateFolder]}
				/>
				<ButtonHeader
					text={notaryFolderNavArchivedLabel()}
					path={Routes.pages.Folder.FolderArchived.base}
					routesActive={[Routes.pages.Folder.FolderArchived.base]}
				/>
			</>
		</Rules>
	);
}
